<template>
  <v-card>
    <v-sheet max-width="100%" height="100%" color="#158760" elevation="6">
      <h3 class="title white--text pa-4 text-center">
        {{ $t("authorizedTransactionsChartTitle") }}
      </h3>
      <v-progress-circular
        v-if="loading"
        class="my-4 mx-auto d-block"
        indeterminate
        color="primary"
        :size="50"
        :width="7"
      ></v-progress-circular>
      <bar-chart
        v-else-if="allData.length > 0"
        :styles="chartStyles"
        :chart-data="chartData"
        :options="chartOptions"
      ></bar-chart>
      <p v-else class="white--text px-4 my-4 text-center">No data found</p>
    </v-sheet>
  </v-card>
</template>

<script>
import { format } from "date-fns";
import { mapState } from "vuex";
import formattedDate from "@/mixins/formattedDate";
import { getCurrencySign } from "@/static/currencies";
import BarChart from "@/components/charts/BarChart.js";

export default {
  name: "CapturedTransactionsChart",
  components: {
    BarChart,
  },
  mixins: [formattedDate],
  props: {
    loading: {
      required: true,
      type: Boolean,
    },
    chartItems: {
      required: true,
      type: Array,
    },
  },
  data: () => ({
    allData: [],
    chartStyles: {
      height: "300px",
      padding: "10px 10px 0 10px",
    },
    chartData: {},
    chartOptions: {},
  }),
  computed: {
    currencySign() {
      let sign = "";
      const currencySign = getCurrencySign(this.currentHotel.currencyCode);
      if (currencySign) {
        sign = currencySign;
      }
      return sign;
    },
    ...mapState(["currentHotel"]),
  },
  watch: {
    chartItems: {
      immediate: true,
      deep: true,
      handler(val) {
        this.createChartData(val);
      },
    },
  },
  methods: {
    createChartData(messages) {
      let data = [];
      if (messages.length) {
        data = messages.map((item) => {
          return {
            x: format(item.targetDate, "DD-MM"),
            y: item.amount,
            count: item.count,
            date: item.targetDate,
          };
        });
        this.createChart(data);
      }
      this.allData = data;
    },
    createChart(data) {
      const dateFormat = "DD-MM";
      let chartOptions = {
        maintainAspectRatio: false,
        legend: {
          display: false,
        },
        tooltips: {
          yPadding: 8,
          xPadding: 8,
          borderColor: "#ffffff",
          borderWidth: 1,
          caretSize: 8,
          displayColors: false,
          callbacks: {
            title: (item, data) => {
              return this.formattedDate(
                data.datasets[0].data[item[0].index].date,
                "D MMM"
              );
            },
            label: (item, data) => {
              const label = [
                this.$t("transactions") +
                  ": " +
                  data.datasets[0].data[item.index].count,
                this.$t("amount") +
                  ": " +
                  this.currencySign +
                  " " +
                  parseFloat(item.yLabel).toFixed(2).toString(),
              ];
              return label;
            },
          },
        },
        scales: {
          xAxes: [
            {
              type: "time",
              color: "#fff",
              time: {
                parser: dateFormat,
                unit: "day",
                unitStepSize: 1,
                displayFormats: {
                  day: "DD-MM",
                },
              },
              display: true,

              gridLines: {
                display: true,
                drawBorder: true,
                borderDash: [2, 2],
                color: "#fff",
                zeroLineColor: "#fff",
              },
              ticks: {
                display: true,
                fontColor: "#fff",
              },
            },
          ],
          yAxes: [
            {
              display: true,
              gridLines: {
                display: true,
                drawBorder: true,
                borderDash: [2, 2],
                color: "#fff",
                zeroLineColor: "#fff",
              },
              ticks: {
                display: true,
                beginAtZero: true,
                fontColor: "white",
              },
            },
          ],
        },
      };

      const chartData = {
        datasets: [
          {
            data: data,
            backgroundColor: "#FDB929",
          },
        ],
      };
      this.chartData = chartData;
      this.chartOptions = chartOptions;
    },
  },
};
</script>
